import distributeBalanceUnallocated from './distribute-balance-unallocated.json';

export default {
  'unallocated-balance': {
    ...distributeBalanceUnallocated,
  },
};
